import { render, staticRenderFns } from "./radio-group.generic.vue?vue&type=template&id=4ccdb4e1&"
import script from "./radio-group.generic.vue?vue&type=script&lang=js&"
export * from "./radio-group.generic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports